/**
 * @module app.shared
 */

import { autoinject, Parser, Binding } from 'aurelia-framework';
import { rebaseExpression } from 'app/shared/lib/extensions/aurelia';

@autoinject
export class DynamicExpressionBindingBehavior {

    constructor(public parser: Parser) { }

    private bind(binding: Binding, source: any, expression: string) {
        if(!expression) { return; }
        //console.log('expression: ' + expression);

        let parsedExpression = this.parser.parse(expression);
        parsedExpression = rebaseExpression(parsedExpression, binding.sourceExpression || null);
        (binding as any).originalSourceExpression = binding.sourceExpression;
        binding.sourceExpression = parsedExpression;
    }

    private unbind(binding: Binding, source: any) {
        binding.sourceExpression = (binding as any).originalSourceExpression;
        (binding as any).originalSourceExpression = null;
    }

}
